export type Language = 'es' | 'en'

export const translations = {
  es: {
    promo: {
      discount: '20% OFF',
      event: 'Día de la Madre · Del 5 al 11 de mayo',
      book: 'Reserva ahora',
    },
    header: {
      services: 'Servicios',
      protocol: 'Protocolo',
      about: 'Sobre Kate',
      reviews: 'Reseñas',
      faq: 'FAQ',
      giftCard: 'Gift Card',
      contact: 'Contacto',
      bookNow: 'Agenda Tu Cita',
    },
    hero: {
      badge: 'Piel Sana, No Perfecta',
      title1: '"Menos filtros, más salud.',
      title2: 'El enfoque real que tu piel merece."',
      subtitle:
        'Descubre el protocolo personalizado que está transformando pieles. Sin tratamientos genéricos, solo resultados reales.',
      bookNow: 'Reserva ahora',
    },
    pain: {
      title: '¿Estás cansada de invertir en tu piel... y no ver resultados?',
      p1: 'Entiéndelo bien: No estás haciendo nada mal.',
      p2: 'Eres inteligente. Investigas. Lees ingredientes. Cambias de productos cuando algo no funciona. Sigues las tendencias de skincare. Has probado lo que funciona para otras personas.',
      p3: 'Y aun así, tu piel sigue sin responder como quieres.',
      quote:
        'El acné aparece cuando menos lo esperas. Las manchas no se van. Los poros parecen abiertos sin importar lo que uses. La piel luce opaca, sin vida, sin ese brillo que ves en otras mujeres y te preguntas: ¿qué tienen ellas que yo no tengo?',
      truth:
        'Aquí está la verdad que la industria de belleza no quiere que sepas:',
      highlight:
        'Los productos no transforman pieles. Los protocolos personalizados, sí.',
      p4: 'Y hay una diferencia enorme entre ir a un spa a "mimarte" y recibir un tratamiento correctivo diseñado para TU tipo de piel, TU condición específica, y TU objetivo real.',
      p5: 'Esa diferencia… marca un antes y un después.',
    },
    testimonials: {
      title: 'El Dolor Real — Lo Que Nadie Dice en Voz Alta',
      p1: 'Hay algo que muchas mujeres sienten pero pocas confiesan:',
      highlight: 'La piel afecta cómo te presentas al mundo.',
      p2: 'No debería ser así. Lo sabemos. Pero lo es.',
      p3: 'Cuando tienes un brote de acné, cancelas planes. Cuando tienes manchas, usas más maquillaje del que quisieras. Cuando tu piel no se ve bien, hablas menos, te fotografías menos, te permites menos.',
      p4: 'Y eso no es vanidad. Es humanidad.',
      p5: 'Tu piel es lo primero que el mundo ve. Y cuando no te sientes cómoda en ella, algo en ti se apaga.',
      subtitle: 'Las clientas de Kate lo describen así:',
      footer:
        'Esto no es marketing. Son mujeres reales. Con pieles reales. Que encontraron a alguien que finalmente las escuchó.',
      button: 'Ver Todas las Reseñas en Google',
    },
    whyFail: {
      title: 'Por Qué Todo Lo Que Has Probado Ha Fallado',
      subtitle:
        'Antes de hablar de la solución, necesitas entender por qué las otras soluciones no funcionaron — y no fue tu culpa.',
      f1_title: 'Cremas del supermercado',
      f1_desc:
        "Fueron diseñadas para el mercado masivo. Para 'todo tipo de piel.' Eso significa: para ningún tipo de piel en específico. Tu piel no es masiva. Es única.",
      f2_title: 'Rutinas de TikTok',
      f2_desc:
        'Muestran rutinas que le funcionaron a alguien más, con otra piel, en otro clima, con otro estilo de vida. La información sin personalización puede dañar más de lo que ayuda.',
      f3_title: 'Spas genéricos',
      f3_desc:
        'Ofrecen relajación. Y eso es válido. Pero relajación no es corrección. Un facial sin diagnóstico es como tomar un medicamento sin saber qué tienes.',
      f4_title: 'Dermatólogos',
      f4_desc:
        'Excelentes para lo médico, pero raramente trabajan la piel desde el exterior con la precisión estética que ella necesita.',
      conclusion1: 'La razón por la que nada ha funcionado es simple:',
      conclusion2:
        'No era falta de cuidado, era falta de un protocolo personalizado.',
    },
    protocol: {
      title: 'El Protocolo "Piel Sana, No Perfecta"',
      p1: 'Kate no cree en la piel perfecta.',
      p2: 'Cree en la piel sana. En la piel tuya. En la piel que refleja quién eres, sin filtros ni escondites.',
      p3: 'Su enfoque es diferente desde el primer minuto:',
      s1_title: 'Antes de tocarte, te evalúa.',
      s1_desc:
        "Analiza tu tipo de piel, tu historia, tus hábitos, tus preocupaciones específicas. Construye un mapa de lo que tu piel necesita — no de lo que funciona 'en general.'",
      s2_title: 'Luego diseña tu protocolo.',
      s2_desc:
        'Combinando técnicas avanzadas de cuidado coreano con tecnología de última generación disponible en su spa, Kate selecciona el tratamiento exacto para tu condición. No más. No menos.',
      s3_title: 'Y te acompaña en el proceso.',
      s3_desc:
        'No te vende una sesión y desaparece. Te guía. Te educa. Te enseña a entender tu propia piel para que los resultados duren mucho más allá de la sala de tratamiento.',
    },
    about: {
      title1: 'Conoce a Kate',
      title2: 'La Mujer Detrás de los Resultados',
      badge: '5 Estrellas en Google',
      p1: 'Kate no llegó a la estética por accidente. Llegó porque vivió el problema.',
      p2: 'Como muchas de sus clientas, luchó con el acné. Conoce de primera mano lo que es mirarse al espejo y no sentirse cómoda con lo que ve. Eso la llevó a estudiar, a investigar, a formarse en las mejores técnicas del mercado.',
      p3_1: 'Hoy es ',
      p3_bold: 'Licenciada Cosmetóloga y Esteticista en Nueva Jersey',
      p3_2: ', egresada de Parisian Paul Mitchell — una de las instituciones más respetadas del sector.',
      p4: 'Y ha convertido su historia personal en una misión profesional: Transformar pieles con precisión, cuidado y honestidad.',
      p5: 'Con una calificación perfecta de 5 estrellas de reseñas en Google, Kate no necesita convencerte con palabras. Sus resultados hablan.',
    },
    featured: {
      title: 'Tratamientos Destacados',
      badge: 'EL MÁS SOLICITADO',
      hero_title: 'Tratamiento para el Acné',
      hero_desc:
        'Un procedimiento estético 100% personalizado diseñado para controlar el acné activo, prevenir brotes futuros y restaurar el equilibrio de tu piel — sin agredirla.',
      who_title: '¿Para quién es?',
      who_desc:
        'Indicado para pieles con acné activo o recurrente, comedogénico o inflamatorio, asociado a alteraciones en la producción de sebo y obstrucción del folículo pilosebáceo.',
      duration_label: 'Duración:',
      duration_val: '90 min',
      freq_label: 'Frecuencia:',
      freq_val: 'Cada 8-15 días',
      achieve_title: '¿Qué logra?',
      achieve_1:
        'Elimina impurezas, bacterias y células muertas que obstruyen los poros',
      achieve_2: 'Disminuye inflamación, enrojecimiento y brotes activos',
      achieve_3: 'Previene la formación de nuevos brotes recurrentes',
      achieve_4: 'Mejora textura, tono y cicatrización de la piel',
      achieve_5: 'Regula la producción de sebo',
      t1_title: 'Hydrafacial',
      t1_desc:
        'Es un procedimiento no invasivo que limpia, exfolia, extrae impurezas y al mismo tiempo hidrata la piel con sueros personalizados.',
      t2_title: 'Exosomas',
      t2_desc:
        'Regeneración celular de vanguardia. Potencia exponencialmente los resultados con microneedling. Ideal para el rejuvenecimiento profundo de la piel.',
      t3_title: 'Microdermoabrasión',
      t3_desc:
        'Mejora la textura y el tono de la piel. Deja la piel más suave, luminosa y rejuvenecida.',
      t4_title: 'GLOW2 Facial',
      t4_desc:
        'Es un tratamiento de alta tecnología que exfolia, oxigena y estimula la piel desde adentro aplicando activos específicos según lo que tu piel necesite. Es perfecto si buscas un efecto rejuvenecedor, hidratante y luminoso sin agujas ni dolor.',
    },
    services: {
      title: 'Menú de Servicios',
      subtitle:
        'Cada tratamiento es adaptado a las necesidades específicas de tu piel tras una evaluación detallada.',
      main_title: 'Tratamientos Faciales Principales',
      eyes_title: 'Ojos y Cejas',
      other_title: 'Otros Servicios',
      gift_title: 'Gift Card',
      gift_desc: 'Un regalo para quien siempre cuida a los demás.',
      gift_btn: 'Comprar Gift Card',
      s1_name: 'Tratamiento Profundo',
      s1_desc: 'Limpieza profunda y corrección intensiva',
      s2_name: 'Hydrafacial',
      s2_desc:
        'Limpia + exfolia + hidrata en una sola sesión. Sin agujas, sin dolor. Resultados inmediatos',
      s3_name: 'Hydrafacial + Dermaplaning',
      s3_desc: 'Combo premium de hidratación y suavizado de piel',
      s4_name: 'Hydrafacial + Peeling Químico',
      s4_desc: 'Renovación profunda con efecto luminoso',
      s5_name: 'Carboxy Terapia',
      s5_desc: 'Estimulación celular con CO₂ para rejuvenecimiento',
      s6_name: 'Tratamiento LIF UP',
      s6_desc: 'Efecto lifting no invasivo',
      s7_name: 'Rejuvenecimiento Facial',
      s7_desc: 'Restaura firmeza y vitalidad de la piel',
      s8_name: 'Peeling Químico',
      s8_desc: 'Exfoliación química controlada para renovar capas de piel',
      s9_name: 'Green Peel',
      s9_desc: 'Peeling herbal natural de acción regeneradora',
      s10_name: 'Dermaplaning',
      s10_desc: 'Elimina vello facial y células muertas para piel sedosa',
      s11_name: 'Dermaplaning + Tratamiento Profundo',
      s11_desc: 'Doble acción: suavidad + corrección',
      s12_name: 'Microdermoabrasión',
      s12_desc: 'Seguro, sin dolor, con resultados desde la primera sesión',
      s13_name: 'GLOW2 Facial',
      s13_desc:
        'Efecto rejuvenecedor, hidratante y luminoso. Sin agujas ni dolor',
      s14_name: 'Exosomas',
      s14_desc:
        'Regeneración celular avanzada. Potencia resultados de microneedling',
      s15_name: 'PDRN de Salmón',
      s15_desc: 'Bioestimulación de última generación para reparar y regenerar',
      e1_name: 'Lifting de Pestañas',
      e1_desc:
        'Eleva, curva y realza tus pestañas naturales. Duración: 4-8 semanas.',
      e2_name: 'Laminado de Cejas',
      e2_desc:
        'Alisa, peina y fija los vellos hacia arriba para un efecto definido.',
      o1_name: 'Tratamiento Profundo para Espalda',
      o1_desc: 'Limpieza y corrección del acné en espalda',
      o2_name: 'Tratamiento Profundo para Espalda + Peeling',
      o2_desc: 'Corrección intensiva + renovación',
      o3_name: 'Mascarilla Hidroplástica',
      o3_desc: 'Hidratación profunda con efecto sellado',
      o4_name: 'Extracciones en Una Sola Área',
      o4_desc: 'Limpieza focalizada sin trauma para la piel',
      o5_name: 'Remoción de Verrugas',
      o5_desc: 'Segura. Eficaz. Sin cicatrices.',
    },
    guarantee: {
      title: 'Inversión Sin Riesgo — Nuestra Garantía de Experiencia',
      p1: 'En Tairu Aesthetics, cada sesión comienza con una evaluación honesta de tu piel.',
      p2: 'Si el tratamiento no es el adecuado para ti en este momento, Kate te lo dirá.',
      p3: 'No te vendemos lo que no necesitas. Te damos lo que tu piel realmente requiere.',
      p4: 'Eso es lo que hace que todas las clientas hayan dejado reseñas de 5 estrellas.',
      p5: 'No por suerte. Por honestidad.',
    },
    hours: {
      title: 'Visítanos',
      location: 'Ubicación',
      contact: 'Contacto',
      hours_title: 'Horarios de Atención',
      mon_fri: 'Lunes a Viernes',
      sat: 'Sábado',
      sun: 'Domingo',
      footer: 'Abiertos 7 días a la semana para adaptarnos a tu vida.',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      q1: 'No sé si funciona para mi tipo de piel',
      a1: 'En Tairu evaluamos tu piel antes de cualquier tratamiento. No aplicamos nada sin un diagnóstico previo. Si no es apto para ti, te lo decimos con total honestidad.',
      q2: '¿Y si tengo piel sensible?',
      a2: 'En Tairu nuestra especialización en corrección no significa agresividad. Trabajamos con protocolos adaptados incluso para pieles hipersensibles.',
      q3: 'Los resultados tardan mucho',
      a3: 'Muchas de nuestras clientas notan diferencia desde la primera sesión. En Tairu construimos resultados profundos y duraderos en el tiempo — y te guiamos en cada paso del proceso.',
      q4: 'Ya probé muchas cosas y nada funcionó',
      a4: 'Exactamente por eso estás aquí. Lo que no funcionó antes fue diseñado para otra persona. En Tairu diseñamos un protocolo exclusivamente para ti.',
      q5: 'No tengo tiempo',
      a5: 'En Tairu estamos abiertos 7 días a la semana, incluyendo domingos. Siempre hay un horario que se adapta a tu vida.',
      q6: '¿Es costoso?',
      a6: 'El costo varía según el tratamiento, pero considera cuánto has gastado en productos que no funcionaron. En Tairu creemos que una sesión correctiva bien aplicada es la inversión más inteligente que puedes hacer por tu piel.',
    },
    cta: {
      title: 'Tu piel lleva demasiado tiempo esperando. Agenda tu cita hoy.',
      subtitle:
        'Una sola sesión puede cambiar cómo ves tu piel — y cómo el mundo te ve a ti.',
      btn: 'Agenda por WhatsApp',
      footer: 'Abierto 7 días a la semana',
    },
    footer: {
      tagline: 'Piel Sana, No Perfecta',
      privacy: 'Política de Privacidad',
      terms: 'Términos y Condiciones',
      rights: 'Todos los derechos reservados.',
      reviews: 'Ver Reseñas en Google',
      payments: 'Tarjetas que aceptamos',
    },
    whatsapp: {
      label: 'Contactar por WhatsApp',
    },
  },
  en: {
    promo: {
      discount: '20% OFF',
      event: "Mother's Day · May 5th to 11th",
      book: 'Book now',
    },
    header: {
      services: 'Services',
      protocol: 'Protocol',
      about: 'About Kate',
      reviews: 'Reviews',
      faq: 'FAQ',
      giftCard: 'Gift Card',
      contact: 'Contact',
      bookNow: 'Book Now',
    },
    hero: {
      badge: 'Healthy Skin, Not Perfect',
      title1: '"Fewer filters, more health.',
      title2: 'The real approach your skin deserves."',
      subtitle:
        'Discover the personalized protocol that is transforming skin. No generic treatments, just real results.',
      bookNow: 'Book now',
    },
    pain: {
      title:
        'Are you tired of investing in your skin... and not seeing results?',
      p1: 'Understand this: You are not doing anything wrong.',
      p2: "You are smart. You research. You read ingredients. You switch products when something doesn't work. You follow skincare trends. You've tried what works for other people.",
      p3: "And yet, your skin still doesn't respond the way you want.",
      quote:
        "Acne appears when you least expect it. Dark spots won't go away. Pores seem open no matter what you use. Your skin looks dull, lifeless, without that glow you see on other women and you wonder: what do they have that I don't?",
      truth: "Here is the truth the beauty industry doesn't want you to know:",
      highlight: "Products don't transform skin. Personalized protocols do.",
      p4: 'And there is a huge difference between going to a spa to "pamper yourself" and receiving a corrective treatment designed for YOUR skin type, YOUR specific condition, and YOUR real goal.',
      p5: 'That difference... marks a before and after.',
    },
    testimonials: {
      title: 'The Real Pain — What No One Says Out Loud',
      p1: 'There is something many women feel but few confess:',
      highlight: 'Your skin affects how you present yourself to the world.',
      p2: "It shouldn't be that way. We know. But it is.",
      p3: "When you have an acne breakout, you cancel plans. When you have dark spots, you use more makeup than you'd like. When your skin doesn't look good, you talk less, take fewer photos, allow yourself less.",
      p4: 'And that is not vanity. It is humanity.',
      p5: "Your skin is the first thing the world sees. And when you don't feel comfortable in it, something inside you turns off.",
      subtitle: "Kate's clients describe it like this:",
      footer:
        'This is not marketing. These are real women. With real skin. Who found someone who finally listened to them.',
      button: 'View All Google Reviews',
    },
    whyFail: {
      title: "Why Everything You've Tried Has Failed",
      subtitle:
        "Before talking about the solution, you need to understand why other solutions didn't work — and it wasn't your fault.",
      f1_title: 'Supermarket creams',
      f1_desc:
        "They were designed for the mass market. For 'all skin types.' That means: for no specific skin type. Your skin is not mass market. It is unique.",
      f2_title: 'TikTok routines',
      f2_desc:
        'They show routines that worked for someone else, with different skin, in a different climate, with a different lifestyle. Information without personalization can harm more than it helps.',
      f3_title: 'Generic spas',
      f3_desc:
        'They offer relaxation. And that is valid. But relaxation is not correction. A facial without diagnosis is like taking medication without knowing what you have.',
      f4_title: 'Dermatologists',
      f4_desc:
        'Excellent for medical issues, but rarely work the skin from the outside with the aesthetic precision it needs.',
      conclusion1: 'The reason nothing has worked is simple:',
      conclusion2:
        "It wasn't lack of care, it was lack of a personalized protocol.",
    },
    protocol: {
      title: 'The "Healthy Skin, Not Perfect" Protocol',
      p1: "Kate doesn't believe in perfect skin.",
      p2: 'She believes in healthy skin. In your skin. In the skin that reflects who you are, without filters or hiding places.',
      p3: 'Her approach is different from the first minute:',
      s1_title: 'Before touching you, she evaluates you.',
      s1_desc:
        "She analyzes your skin type, your history, your habits, your specific concerns. She builds a map of what your skin needs — not what works 'in general.'",
      s2_title: 'Then she designs your protocol.',
      s2_desc:
        'Combining advanced Korean skincare techniques with state-of-the-art technology available in her spa, Kate selects the exact treatment for your condition. No more. No less.',
      s3_title: 'And she accompanies you in the process.',
      s3_desc:
        "She doesn't sell you a session and disappear. She guides you. She educates you. She teaches you to understand your own skin so results last long beyond the treatment room.",
    },
    about: {
      title1: 'Meet Kate',
      title2: 'The Woman Behind the Results',
      badge: '5 Stars on Google',
      p1: "Kate didn't get into aesthetics by accident. She got into it because she lived the problem.",
      p2: "Like many of her clients, she struggled with acne. She knows firsthand what it's like to look in the mirror and not feel comfortable with what you see. That led her to study, research, and train in the best techniques on the market.",
      p3_1: 'Today she is a ',
      p3_bold: 'Licensed Cosmetologist and Esthetician in New Jersey',
      p3_2: ', graduated from Parisian Paul Mitchell — one of the most respected institutions in the industry.',
      p4: 'And she has turned her personal story into a professional mission: Transforming skin with precision, care, and honesty.',
      p5: "With a perfect 5-star rating from Google reviews, Kate doesn't need to convince you with words. Her results speak.",
    },
    featured: {
      title: 'Featured Treatments',
      badge: 'MOST REQUESTED',
      hero_title: 'Acne Treatment',
      hero_desc:
        "A 100% personalized aesthetic procedure designed to control active acne, prevent future breakouts, and restore your skin's balance — without aggression.",
      who_title: 'Who is it for?',
      who_desc:
        'Indicated for skin with active or recurrent, comedogenic or inflammatory acne, associated with alterations in sebum production and obstruction of the pilosebaceous follicle.',
      duration_label: 'Duration:',
      duration_val: '90 min',
      freq_label: 'Frequency:',
      freq_val: 'Every 8-15 days',
      achieve_title: 'What does it achieve?',
      achieve_1:
        'Eliminates impurities, bacteria, and dead cells that clog pores',
      achieve_2: 'Reduces inflammation, redness, and active breakouts',
      achieve_3: 'Prevents the formation of new recurrent breakouts',
      achieve_4: 'Improves skin texture, tone, and healing',
      achieve_5: 'Regulates sebum production',
      t1_title: 'Hydrafacial',
      t1_desc:
        'It is a non-invasive procedure that cleanses, exfoliates, extracts impurities, and at the same time hydrates the skin with personalized serums.',
      t2_title: 'Exosomes',
      t2_desc:
        'Cutting-edge cellular regeneration. Exponentially boosts results with microneedling. Ideal for deep skin rejuvenation.',
      t3_title: 'Microdermabrasion',
      t3_desc:
        'Improves skin texture and tone. Leaves skin softer, more luminous, and rejuvenated.',
      t4_title: 'GLOW2 Facial',
      t4_desc:
        'It is a high-tech treatment that exfoliates, oxygenates, and stimulates the skin from within by applying specific active ingredients according to what your skin needs. It is perfect if you are looking for a rejuvenating, hydrating, and luminous effect without needles or pain.',
    },
    services: {
      title: 'Services Menu',
      subtitle:
        "Each treatment is adapted to your skin's specific needs after a detailed evaluation.",
      main_title: 'Main Facial Treatments',
      eyes_title: 'Eyes & Brows',
      other_title: 'Other Services',
      gift_title: 'Gift Card',
      gift_desc: 'A gift for the one who always takes care of others.',
      gift_btn: 'Buy Gift Card',
      s1_name: 'Deep Treatment',
      s1_desc: 'Deep cleansing and intensive correction',
      s2_name: 'Hydrafacial',
      s2_desc:
        'Cleanses + exfoliates + hydrates in a single session. No needles, no pain. Immediate results',
      s3_name: 'Hydrafacial + Dermaplaning',
      s3_desc: 'Premium combo for hydration and skin smoothing',
      s4_name: 'Hydrafacial + Chemical Peel',
      s4_desc: 'Deep renewal with a luminous effect',
      s5_name: 'Carboxy Therapy',
      s5_desc: 'Cellular stimulation with CO₂ for rejuvenation',
      s6_name: 'LIF UP Treatment',
      s6_desc: 'Non-invasive lifting effect',
      s7_name: 'Facial Rejuvenation',
      s7_desc: 'Restores skin firmness and vitality',
      s8_name: 'Chemical Peel',
      s8_desc: 'Controlled chemical exfoliation to renew skin layers',
      s9_name: 'Green Peel',
      s9_desc: 'Natural herbal peel with regenerative action',
      s10_name: 'Dermaplaning',
      s10_desc: 'Removes facial hair and dead cells for silky skin',
      s11_name: 'Dermaplaning + Deep Treatment',
      s11_desc: 'Double action: smoothness + correction',
      s12_name: 'Microdermabrasion',
      s12_desc: 'Safe, painless, with results from the first session',
      s13_name: 'GLOW2 Facial',
      s13_desc:
        'Rejuvenating, hydrating, and luminous effect. No needles or pain',
      s14_name: 'Exosomes',
      s14_desc: 'Advanced cellular regeneration. Boosts microneedling results',
      s15_name: 'Salmon PDRN',
      s15_desc: 'Latest generation biostimulation to repair and regenerate',
      e1_name: 'Lash Lift',
      e1_desc:
        'Lifts, curls, and enhances your natural lashes. Duration: 4-8 weeks.',
      e2_name: 'Brow Lamination',
      e2_desc: 'Smooths, styles, and sets hairs upward for a defined effect.',
      o1_name: 'Deep Back Treatment',
      o1_desc: 'Cleansing and acne correction on the back',
      o2_name: 'Deep Back Treatment + Peel',
      o2_desc: 'Intensive correction + renewal',
      o3_name: 'Hydroplastic Mask',
      o3_desc: 'Deep hydration with sealing effect',
      o4_name: 'Single Area Extractions',
      o4_desc: 'Targeted cleansing without skin trauma',
      o5_name: 'Wart Removal',
      o5_desc: 'Safe. Effective. No scars.',
    },
    guarantee: {
      title: 'Risk-Free Investment — Our Experience Guarantee',
      p1: 'At Tairu Aesthetics, every session begins with an honest evaluation of your skin.',
      p2: 'If the treatment is not right for you at this time, Kate will tell you.',
      p3: "We don't sell you what you don't need. We give you what your skin really requires.",
      p4: "That's what makes all our clients leave 5-star reviews.",
      p5: 'Not by luck. By honesty.',
    },
    hours: {
      title: 'Visit Us',
      location: 'Location',
      contact: 'Contact',
      hours_title: 'Business Hours',
      mon_fri: 'Monday to Friday',
      sat: 'Saturday',
      sun: 'Sunday',
      footer: 'Open 7 days a week to fit your life.',
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: "I don't know if it works for my skin type",
      a1: 'At Tairu we evaluate your skin before any treatment. We do not apply anything without a prior diagnosis. If it is not suitable for you, we tell you with complete honesty.',
      q2: 'What if I have sensitive skin?',
      a2: 'At Tairu our specialization in correction does not mean aggressiveness. We work with protocols adapted even for hypersensitive skin.',
      q3: 'Results take too long',
      a3: 'Many of our clients notice a difference from the first session. At Tairu we build deep and lasting results over time — and we guide you every step of the way.',
      q4: "I've tried many things and nothing worked",
      a4: "Exactly why you are here. What didn't work before was designed for someone else. At Tairu we design a protocol exclusively for you.",
      q5: "I don't have time",
      a5: 'At Tairu we are open 7 days a week, including Sundays. There is always a schedule that fits your life.',
      q6: 'Is it expensive?',
      a6: 'The cost varies depending on the treatment, but consider how much you have spent on products that did not work. At Tairu we believe that a well-applied corrective session is the smartest investment you can make for your skin.',
    },
    cta: {
      title:
        'Your skin has been waiting too long. Book your appointment today.',
      subtitle:
        'A single session can change how you see your skin — and how the world sees you.',
      btn: 'Book via WhatsApp',
      footer: 'Open 7 days a week',
    },
    footer: {
      tagline: 'Healthy Skin, Not Perfect',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      rights: 'All rights reserved.',
      reviews: 'View Google Reviews',
      payments: 'Cards we accept',
    },
    whatsapp: {
      label: 'Contact via WhatsApp',
    },
  },
}
